export const getAuthToken = () => {
    return localStorage.getItem("token") || null;
  };
  
  export const setAuthToken = (token) => {
    localStorage.setItem("token", token);
  };
  
  export const clearAuthToken = () => {
    localStorage.removeItem("token");
  };
  